"use strict";

require("core-js/modules/es.array.slice.js");
require("core-js/modules/es.object.define-properties.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.freeze.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SliderInputContainer = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _constellation = require("@zillow/constellation");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var SliderInputContainer = exports.SliderInputContainer = (0, _styledComponents["default"])(_constellation.Spacer)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 50%;\n  max-width: calc(50% - 12px);\n\n  @media (max-width: 649px) {\n    width: 100%;\n    max-width: 100%;\n    padding: 16px 0;\n  }\n"])));